import { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { PendingPciListColumns } from '../../appconfig/DatatableSetting';
import { defaultRowOptions, statusFilterOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, filterDegreeList } from '../../appconfig/Settings';
import { getAllDetails, getAllDetailsDirect, postAllData } from '../../service/ProductService';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { APP_HOSPITAL, PCI_APPROVAL_STATUS, PENDING_PCI_APPROVALS, UNIVERSITY } from '../../config/ApiConstant';
import { CollegeManageTab } from './CollegeManageTab';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import CustomDatePicker from '../../components/CustomDatePicker/CustomDatePicker';
import { PendingApprovalMasterValidate } from '../../config/Validate';
import { convertDate, convertMonthFormat } from '../../appconfig/AppHelper';
import { useNavigate } from 'react-router-dom';
import { InputNumber } from 'primereact/inputnumber';

export const PendingPciApprovalList = () => {
    document.title = 'Pending PCI Approval List | GSPC';

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();

    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    const [loading, setLoading] = useState(false);
    const [pendingPciList, setPendingPciList] = useState<any[]>([]);
    const [statusValue, setStatusValue] = useState<any>(null);
    const [degreeValue, setDegreeValue] = useState<any>(null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);

    const [universityList, setUniversityList] = useState<any>([]);
    const [hospitalList, setHospitalList] = useState<any>([]);

    const [approvalData, setApprovalData] = useState<any>({});
    const [date, setDate] = useState<any>();
    const [errors, setErrors] = useState<any>({});
    const [submitLoading, setSubmitLoading] = useState(false);

    const [fromDates, setFromDates] = useState({
        start: new Date(),
        end: new Date()
    });

    // ufeeffect
    useEffect(() => {
        getPciApprovalList();
        getAllUniversity();
        getAllHospital();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // get api approval list api
    const getPciApprovalList = async () => {
        try {
            setLoading(true);
            const response = await getAllDetails(PENDING_PCI_APPROVALS);
            setPendingPciList(response || []);
        } catch {
            setPendingPciList([]);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Sorry, could not load data' });
        } finally {
            setLoading(false);
        }
    };

    // clear all
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setStatusValue(null);
        setGlobalFilter(null);
    };

    // status change funtion to open dialog
    const handleStatusChange = (row: any, value: boolean) => {
        row.pci_code = "PCI/" + row.pci_code;
        setSelectedRow(row);
        setDialogVisible(true);
    };

    // onsubmit api call
    const onSubmitStatus = async () => {

        try {
            const { errors: vErrors, isError } = PendingApprovalMasterValidate(approvalData, selectedRow);

            setErrors(vErrors);
            if (isError) return;

            

            setSubmitLoading(true);

            const pciCircularDateConvert = convertDate(date);
            const approvalYearFromCon = convertMonthFormat(fromDates.start);
            const approvalYearToCon = convertMonthFormat(fromDates.end);

            const fromDateApproval = new Date(fromDates.start);
            const validMonthF = fromDateApproval.getMonth() + 1;
            const validYearF = fromDateApproval.getFullYear();

            const toDateApproval = new Date(fromDates.end);
            const validMonth = toDateApproval.getMonth() + 1;
            const validYear = toDateApproval.getFullYear();

            // req data obj
            const requestData: any = {
                id: selectedRow?.id,
                orgcode: selectedRow?.college_id,
                orgNm: selectedRow?.college_name,
                university: approvalData?.university?.name,
                USrNo: approvalData?.university?.code,
                examauthoSrNo: approvalData?.university?.code,
                subject: approvalData?.subject,
                examautho: approvalData?.university?.name,
                DegNm: approvalData?.degree?.name || selectedRow?.degree_name,
                degree: approvalData?.degree?.code || selectedRow?.degree_id,
                pcirefno: `${selectedRow?.pci_code}`,
                pciresno: approvalData?.pciResNo,
                pcicirdt: pciCircularDateConvert,
                Seat: approvalData?.seatsTotal,
                HospNo1: approvalData?.hospital?.code || '',
                HospNo2: approvalData?.hospital?.name || '',
                qualdateorg: approvalYearFromCon,
                qualdateorgf: approvalYearToCon,
                validmonth: validMonthF,
                validyear: validYearF,
                validmonthf: validMonth,
                validyearf: validYear
            };

            const response = await postAllData(PCI_APPROVAL_STATUS, requestData);
            if (response) {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setDialogVisible(false);
                setApprovalData({});
                getPciApprovalList();
            }
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Status update failed' });
        } finally {
            setSubmitLoading(false);
        }
    };

    // left toolbar
    const leftToolbarTemplate = () => (
        <span className="search-bar mr-3">
            <i className="pi pi-search"></i>
            <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
        </span>
    );

    // right toolbar
    const rightToolbarTemplate = () => <Button icon="pi pi-filter-slash" label="Clear" onClick={clearAll} className="p-button-outlined p-button-primary mr-2" />;

    // file tempalte
    const fileTemplate = (row: any) => (row.approval_file ? <Button icon="pi pi-file" className="p-button-primary" onClick={() => window.open(row.approval_file, '_blank')} tooltip="Open File" tooltipOptions={{ position: 'top' }} /> : null);

    // status template badge & switch
    const statusTemplate = (row: any) => {
        const approved = Number(row.status) === 1;
        return (
            <div className="flex flex-column align-items-center">
                <InputSwitch checked={approved} className="mb-2" disabled={approved} onChange={() => handleStatusChange(row, !approved)} />
                <Badge value={approved ? 'Approved' : 'Pending'} severity={approved ? 'success' : 'warning'} />
            </div>
        );
    };

    // status filter dropdwon
    const statusFilterTemplate = (options: any) => (
        <Dropdown
            filter
            value={statusValue}
            options={statusFilterOptions}
            onChange={(e) => {
                setStatusValue(e.value);
                options.filterCallback(e.value.code, options.index);
            }}
            placeholder="Filter by status"
            className="p-column-filter"
            optionLabel="name"
            showClear
        />
    );

    // filter by degree dropdown
    const filterByDegree = (options: any) => (
        <Dropdown
            filter
            value={degreeValue}
            options={filterDegreeList}
            onChange={(e) => {
                setDegreeValue(e.value);
                options.filterCallback(e.value ? e.value.name : null, options.index);
            }}
            placeholder="Filter by degree"
            className="p-column-filter"
            optionLabel="name"
            showClear
        />
    );

    // on input change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'university' || name === 'hospital') {
            val = e;
        } else if (name === 'seatsTotal') {
            val = e.value;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        //On selected value update
        setApprovalData({ ...approvalData, [name]: val });
    };

    //New Input Change
    const onInputChangeNew = (e: any, selectedRow: any, name: string) => {
        selectedRow.pci_code = e.target.value;
        setSelectedRow({ ...selectedRow, [name]: e.target.value });
    };


    // get all university api call
    const getAllUniversity = async () => {
        try {
            const response = await getAllDetailsDirect(UNIVERSITY + '?type=all');
            const list = (response || []).map((u: any) => ({ name: u.UName, code: u.SrNo }));
            setUniversityList(list);
        } catch {
            setUniversityList([]);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could not load universities' });
        }
    };

    // get all hospital api
    const getAllHospital = async () => {
        try {
            const response = await getAllDetailsDirect(APP_HOSPITAL + '?type=all');
            const list = (response || []).map((h: any) => ({ name: h.HospName, code: h.HospNo }));
            setHospitalList(list);
        } catch {
            setHospitalList([]);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could not load hospitals' });
        }
    };

    // on date change
    const onFromDateChange = (start: any, end: any) => setFromDates({ start, end });

    // on hide dialog
    const onHide = () => {
        setDialogVisible(false);
        setApprovalData({});
        setErrors({});
    };

    return (
        <>
            <CollegeManageTab mainTabLabel="PCI Approval" />
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu="PCI Approval" pageName="Pending PCI Approval List" pageTitle="Pending PCI Approval List" goToPage />

            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} />

                        {!loading ? (
                            <DataTable
                                value={pendingPciList}
                                showGridlines
                                stripedRows
                                globalFilter={globalFilter}
                                filters={globalFieldFilter}
                                onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                rows={defaultRowOptions}
                                paginator={pendingPciList.length >= 10}
                                rowsPerPageOptions={defaultPageRowOptions}
                                className="datatable-responsive p-datatable-sm"
                                paginatorTemplate={paginatorLinks}
                                currentPageReportTemplate={showingEntries}
                                emptyMessage="No Data available"
                                removableSort
                            >
                                {PendingPciListColumns.map((col) => {
                                    if (col.field === 'sr_no') return <Column key={col.field} header={col.header} body={(_: any, { rowIndex }) => rowIndex + 1} />;
                                    if (col.field === 'approval_file') return <Column key={col.field} header={col.header} body={fileTemplate} />;
                                    if (['college_name', 'from_year', 'to_year'].includes(col.field)) return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={`Search by ${col.header}`} sortable />;
                                    if (col.field === 'pci_code') return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={`Search by ${col.header}`} />;
                                    if (col.field === 'degree_name') return <Column key={col.field} field={col.field} header={col.header} filter filterElement={filterByDegree} />;
                                    if (col.field === 'status') return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={statusFilterTemplate} />;
                                    return <Column key={col.field} field={col.field} header={col.header} sortable />;
                                })}
                            </DataTable>
                        ) : (
                            <DataTable value={Skeletonitems}>
                                {PendingPciListColumns.map((col) => (
                                    <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                ))}
                            </DataTable>
                        )}
                    </div>
                </div>
            </div>

            <Dialog
                header="Confirm PCI Approval"
                visible={dialogVisible}
                draggable={false}
                style={{ width: '90vw', maxWidth: '80%' }}
                onHide={onHide}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={onHide} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-success" loading={submitLoading} onClick={onSubmitStatus} />
                    </div>
                }
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label>College *</label>
                        <InputText value={selectedRow?.college_name} disabled />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>University *</label>
                        <Dropdown
                            value={approvalData?.university}
                            options={universityList}
                            filter
                            optionLabel="name"
                            placeholder="Select University"
                            onChange={(e) => onInputChange(e.value, 'university')}
                            className={errors['university'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['university']}</small>
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>Degree *</label>
                        <InputText value={selectedRow?.degree_name} disabled />
                    </div>
                    {selectedRow?.degree_name === "M Pharm" && (
                        <div className="field col-12 md:col-4">
                            <label>
                                Subject *
                            </label>

                            <InputText
                                value={selectedRow?.subject}
                                name="subject"
                                placeholder="Enter subject"
                                onChange={(e) => onInputChange(e, 'subject')}
                                className={errors['subject'] && 'p-invalid'}
                            />

                            <small className="p-invalid-txt">{errors['subject']}</small>
                        </div>
                    )}

                    <div className="field col-12 md:col-4">
                        <label>PCI Res No *</label>
                        <InputText value={approvalData?.pciResNo || ''} placeholder="Enter PCI Res No" onChange={(e) => onInputChange(e, 'pciResNo')} className={errors['pciResNo'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['pciResNo']}</small>
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>PCI Ref No *</label>
                        <InputText value={selectedRow?.pci_code || ''} placeholder="Enter PCI Code"
                            onChange={(e) => onInputChangeNew(e, selectedRow, 'pciRefNo')}
                            className={errors['pciRefNo'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['pciRefNo']}</small>
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>PCI Circular Date</label>
                        <Calendar value={date} dateFormat="dd-M-yy" onChange={(e) => setDate(e.value)} showIcon />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>Seat *</label>
                        <InputNumber value={approvalData?.seatsTotal || ''} placeholder="Enter Seat" onChange={(e) => onInputChange(e, 'seatsTotal')} className={errors['seatsTotal'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['seatsTotal']}</small>
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>From and To Date</label>
                        <CustomDatePicker startDate={fromDates.start} endDate={fromDates.end} onChange={onFromDateChange} />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label>Approved Hospital</label>
                        <Dropdown value={approvalData?.hospital} options={hospitalList} filter optionLabel="name" placeholder="Select Hospital" onChange={(e) => onInputChange(e.value, 'hospital')} className={errors['hospital'] && 'p-invalid'} />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
